import React from 'react';
import { Field, useField } from 'react-final-form';
import { Calendar, DateInput, DatePicker, FormField, FormHelp, Label } from '@zillow/constellation-10';
import { FieldValidator } from '../../../validation/validation';
import { DOB } from '../../../constants/formFieldNames';

const today = new Date();
const date18YearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
const date120YearsAgo = new Date(today.getFullYear() - 120, today.getMonth(), today.getDate());

export default function DateOfBirthField() {
  const { meta } = useField(DOB);
  const { touched, active, error } = meta;
  const isInvalid = touched && !active && Boolean(error);

  return (
    <FormField
      label={<Label>Date of birth</Label>}
      error={isInvalid}
      control={
        <Field
          name={DOB}
          render={({ input }) => {
            return (
              <DatePicker
                minDate={date120YearsAgo}
                disabledDates={(date: Date) => date > date18YearsAgo}
                value={input.value}
                onValueChange={(value) => input.onChange(typeof value === 'string' ? value : '')}
                input={
                  <DateInput
                    name={input.name}
                    onBlur={input.onBlur}
                    onFocus={input.onFocus}
                    className="fs-exclude"
                    placeholder="mm/dd/yyyy"
                  />
                }
                calendar={<Calendar />}
              />
            );
          }}
          validate={(dob: string) => {
            const errors = new FieldValidator(dob)
              .required('Enter a valid date of birth')
              .regex(/^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])\/\d{4}$/, 'Invalid date format (mm/dd/yyyy)')
              .maxDate(new Date(dob), date18YearsAgo, 'Must be 18 years or older')
              .minDate(new Date(dob), date120YearsAgo, 'Enter a date within the past 120 years')
              .build();

            return errors ? errors : null;
          }}
        />
      }
      description={
        isInvalid ? (
          <FormHelp>{error}</FormHelp>
        ) : (
          <FormHelp>You must be 18 years or older to complete the identity verification process</FormHelp>
        )
      }
    />
  );
}
